<router-outlet></router-outlet>
@if (progress$ | async; as progress) {
  <div class="app-progress">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    @if (progress && progress.total > 0) {
      <span class="text-light">{{ ((progress.loaded / progress.total) * 100).toFixed() }}%</span>
      <ngb-progressbar type="primary" [max]="progress.total" [value]="progress.loaded"></ngb-progressbar>
    }
  </div>
}
<div class="app-toasts">
  @for (toast of toasts$ | async; track toast) {
    <ngb-toast [class]="toast.type" [autohide]="true" [delay]="toast.delay" (hidden)="toast.hide()">
      <span class="toast-message">{{ toast.message | translate }}</span>
    </ngb-toast>
  }
</div>
